import React, { useEffect, useState } from "react";
import Select from "react-select";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const ExceptionalSecurityOut = () => {
  const [securitySewadars, setSecuritySewadars] = useState([]);
  const [permitters, setPermitters] = useState([]);

  const [formData, setFormData] = useState({
    permittedBy: null,
    date: "",
    time: "",
    vehicleNo: "",
    driverName: "",
    driverMobileNo: "",
    selectedSewadar: "",
    exitDate: "",
    exitTime: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const code = localStorage.getItem("code");
  const sewadarId = localStorage.getItem("sewadarId");

  // 🔹 Fetch Security Sewadars
  const fetchSecuritySewadars = async () => {
    try {
      const dept = "Security";
      const res = await apiClient.get(
        `${SERVER_BASE}/getOperatorsByDepartment/${code}?department=${dept}`
      );

      const badgeOptions = res.data.map((s) => ({
        value: s.badgeId,
        label: `${s.badgeId} - ${s.fullName}`,
        name: s.fullName,
        sewadarMobileNo: s.mobileNo,
        alternateMobileNo: s.alternateMobileNo,
      }));

      setSecuritySewadars(badgeOptions);
    } catch (err) {
      console.error("Error fetching Security sewadars:", err);
    }
  };

  // 🔹 Fetch Permitters (Office)
  const fetchPermitters = async () => {
    try {
      const dept = "Office";
      const res = await apiClient.get(
        `${SERVER_BASE}/getOperatorsByDepartment/${code}?department=${dept}`
      );

      const badgeOptions = res.data.map((s) => ({
        value: s.badgeId,
        label: `${s.badgeId} - ${s.fullName}`,
        name: s.fullName,
        sewadarMobileNo: s.mobileNo,
        alternateMobileNo: s.alternateMobileNo,
      }));

      setPermitters(badgeOptions);
    } catch (err) {
      console.error("Error fetching permitters:", err);
    }
  };

  useEffect(() => {
    fetchSecuritySewadars();
    fetchPermitters();
  }, []);

  // 🔹 Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, permittedBy: selectedOption }));
  };

  const handleSewadarChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, selectedSewadar: selectedOption }));
  };

  // 🔹 Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload

    // Confirm before submit
    const { isConfirmed } = await Swal.fire({
      title: "क्या आप सुनिश्चित हैं?",
      text: "यह वाहन बाहर के रूप में चिह्नित किया जाएगा।",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "रद्द करें",
      confirmButtonText: "हाँ, आगे बढ़ें",
    });

    if (!isConfirmed) return;

    const payload = {
      ...formData,
      code,
      sewadarId,
      permittedBy: formData.permittedBy?.value || "",
      selectedSewadar: formData.selectedSewadar?.value || "",
      sewadarName: formData.selectedSewadar?.name || "",
      sewadarMobileNo: formData.selectedSewadar?.sewadarMobileNo || "",
      permittedByName:formData.permittedBy?.name
    };

    try {
      await apiClient.post(`${SERVER_BASE}/addExceptionalOut`, payload);
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        icon: "success",
        text: "Security Out Saved successfully.",
        timerProgressBar: true,
        timer: 1200,
      }).then(() => {
        navigate(-1); // go back after saving
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `Failed to save: ${err.response?.data?.message || err.message}`,
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="formcontainer mt-5">
              <div className="col d-flex align-items-center">
          <button
            className="btn btn-secondary me-3 mb-3"
            onClick={() => navigate('../vehicleOut')}
          >
            Cancel
          </button>
          <h4 className="mb-0 ">Exceptional Security Out</h4>
        </div>
      <form onSubmit={handleSubmit}>
        {/* Permitted By, Date, Time */}
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">
              IO ग्रुप पर संदेश किसके द्वारा भेजा गया
            </label>
            <Select
              options={permitters}
              value={formData.permittedBy}
              onChange={handleSelectChange}
              placeholder="चुनें"
              isClearable
              required
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">तारीख</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">समय</label>
            <input
              type="time"
              className="form-control"
              name="time"
              value={formData.time}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Vehicle Info */}
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">वाहन संख्या</label>
            <input
              type="text"
              className="form-control"
              name="vehicleNo"
              value={formData.vehicleNo}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">वाहन चालक का नाम</label>
            <input
              type="text"
              className="form-control"
              name="driverName"
              value={formData.driverName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">मोबाइल नंबर</label>
            <input
              type="tel"
              className="form-control"
              name="driverMobileNo"
              value={formData.driverMobileNo}
              onChange={handleChange}
              pattern="[0-9]{10}"
              required
            />
          </div>
        </div>

        {/* Section Divider */}
        <div className="mt-4 border-top pt-3">
          <h6 className="fw-semibold mb-3">
            वाहन किसके द्वारा बाहर किया गया ( बिलवा गेट नं 1 के सेवादार का विवरण )
          </h6>

          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">बैज आई. डी.</label>
              <Select
                options={securitySewadars}
                value={formData.selectedSewadar}
                onChange={handleSewadarChange}
                placeholder="सेवादार चुनें"
                isSearchable
                required
              />
            </div>

            {formData.selectedSewadar && (
              <>
                <div className="col-md-4 mb-3">
                  <label className="form-label">नाम</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.selectedSewadar.name || ""}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">मोबाइल नंबर</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.selectedSewadar.sewadarMobileNo || ""}
                    readOnly
                  />
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">बाहर निकलने की तारीख</label>
                  <input
                    type="date"
                    className="form-control"
                    name="exitDate"
                    value={formData.exitDate}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">बाहर निकलने का समय</label>
                  <input
                    type="time"
                    className="form-control"
                    name="exitTime"
                    value={formData.exitTime}
                    onChange={handleChange}
                    required
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Submit */}
        <div className="text-end mt-3">
          <button type="submit" className="btn btn-success px-4">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default ExceptionalSecurityOut;
